<footer class="footer">
    <div class="d-sm-flex justify-content-center justify-content-sm-between">
        <span class="text-muted text-center text-sm-left d-block d-sm-inline-block">Copyright © 2023 <a
                href="https://www.mapedia.co.th/" target="_blank">MAPEDIA . co . th</a>. All rights reserved.</span>
    </div>
</footer>